import './index.css'
import { createApp } from 'vue'
window.__BUILD__ = '2026-04-16-hidden-debug';
// Debug banners are always rendered but CSS-hidden; ?debug=1 reveals them.
if (typeof window !== 'undefined' && /[?&]debug=1\b/.test(window.location.search)) {
  document.documentElement.setAttribute('data-debug', '1');
}
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { router } from './router.js'
import App from './App.vue'
import VueSmoothScroll from 'vue3-smooth-scroll'
import VueGtag from "vue-gtag"
import { pageTitle } from 'vue-page-title';

//Constants
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App)

//Use
app.use(pinia)
app.use(router)
app.use(VueSmoothScroll)
app.use(VueGtag, {
  config: {
    id: "G-NN5CG4ZVYJ",
  },
}, router);
app.use(
  pageTitle({
    suffix: '| Public Trust',
    mixin: true,
  })
);

//Mount
app.mount('#app')
